import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import useSessionStorage from '@hooks/useSessionStorage';
import updateHotelFavorites from '@helpers/updateHotelFavorites';
import useIsMobile from '@hooks/useIsMobile';
import ModalContainer from '@components/AuthForm/ModalContainer';
import DownloadDescription from './DownloadDescription';
import Favorites from './Favorites';
import NoFavorites from './NoFavorites';
import FavoritesLoginForm from './FavoritesLoginForm';
import FavoritesLoginFormMobile from './FavoritesLoginFormMobile';

export default function MyFavoritesWrapper() {
  const isMobile = useIsMobile();

  const [cookies] = useCookies(['userInformation']);
  const [userFavoritesIds, setUserFavoritesIds] = useState<any>([]);
  const [userFavoritesMetadata, setUserFavoritesMetadata] = useState<any>({});
  const [showCloseButton, setShowCloseButton] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { getItem } = useSessionStorage();
  const [isRequestComplete, setIsRequestComplete] = useState<boolean>(false);
  const [isLoginButtonClicked, setIsLoginButtonClicked] = useState<boolean>(false);
  const [isSignUpButtonClicked, setIsSignUpButtonClicked] = useState<boolean>(false);

  useEffect(() => {
    if (
      showCloseButton &&
      userFavoritesIds.length === 0 &&
      !isRequestComplete &&
      window.location.href.includes('my-favorites')
    ) {
      updateHotelFavorites(
        cookies,
        setShowCloseButton,
        setUserFavoritesMetadata,
        getItem,
        setUserFavoritesIds,
        setIsLoading,
        setIsRequestComplete,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showFavorites =
    isLoading && userFavoritesIds.length !== 0 && Object.keys(userFavoritesMetadata).length !== 0;
  return (
    <>
      {(isLoginButtonClicked || isSignUpButtonClicked) && (
        <>
          <div className="bg-rp-black-faded fixed h-full left-0 overflow-auto top-0 w-full z-100" />
          <div className="-translate-x-1/2 -translate-y-1/2 fixed flex flex-col items-center justify-between left-1/2 rounded-xl top-1/2 transform-gpu w-full z-100 h-full overflow-y-auto d:h-auto">
            <ModalContainer
              setIsLoginButtonClicked={
                isSignUpButtonClicked ? setIsSignUpButtonClicked : setIsLoginButtonClicked
              }
              isLoginButtonClicked={!isLoginButtonClicked}
              myFavoritesUserSignUp={isSignUpButtonClicked}
            />
          </div>
        </>
      )}
      <div className="relative bg-white py-4 px-22px d:py-7">
        <div className="mx-auto max-w-6xl w-full">
          <div className="font-rp-cera-medium text-2xl leading-30px tracking-extraTight d:text-35 d:leading-10">
            My Favorites
          </div>
          <div className="border-b pb-6" />
        </div>
      </div>
      {showCloseButton &&
        (isMobile ? (
          <FavoritesLoginFormMobile
            setIsLoginButtonClicked={setIsLoginButtonClicked}
            setIsSignUpButtonClicked={setIsSignUpButtonClicked}
          />
        ) : (
          <FavoritesLoginForm
            setShowCloseButton={setShowCloseButton}
            setIsLoginButtonClicked={setIsLoginButtonClicked}
            setIsSignUpButtonClicked={setIsSignUpButtonClicked}
          />
        ))}
      <div className="mx-auto max-w-6xl w-full d:flex d:flex-row d:items-start d:pt-5">
        {showFavorites ? (
          <Favorites
            userFavoritesMetadata={userFavoritesMetadata}
            setUserFavoritesIds={setUserFavoritesIds}
            userFavoritesIds={userFavoritesIds}
          />
        ) : (
          <NoFavorites />
        )}
      </div>
      <div className={`border-b pb-6 mx-auto max-w-6xl ${isMobile ? 'mr-5 ml-5' : 'w-full'}`} />
      {!isMobile && (
        <div className="mx-auto max-w-6xl d:flex d:flex-row d:items-start d:pt-5">
          <DownloadDescription />
        </div>
      )}
    </>
  );
}
